import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import Request from '../../../services/request';
import translate from '../../../commonComponents/translate';
import AddAddressModal from '../modal/AddAddressModal';
import accessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import { useModal } from '../../../services/customHooks';
import Notifications from '../../../services/notifications';
import GoogleInput from '../../../commonComponents/forms/inputs/GoogleInput';
import courseProp from '../../academy/propTypes/courseProp';
import PlaceLocation from './PlaceLocation';
import TabSessionDetailsWebinar from './TabSessionDetailsWebinar';

const TabSessionDetails = (
  {
   t,
   _csrf,
   accessSession,
   createUser,
   createTrainer,
   selectMultiple,
   handleChange,
   courses,
   countries,
   mapsKey,
   isFinished,
   onClassroomUpdate,
    isWebexActive,
    isDuplicate,
}) => {
  const [radio, setRadio] = useState(accessSession.type);
  const [updatedAddress, setUpdatedAddress] = useState(accessSession.classroom?.address?.address);
  const [showAddAddress, setShowAddAddress] = useModal({
    show: false,
  });
  const [mapObj, setMap] = useState(null);
  const [mapMarker, setMapMarker] = useState(null);
  const [zoom, setZoom] = useState(7);
  const [coords, setCoords] = useState({ lat: 49.64009751200398, lng: 6.146707873931527 });
  const defaultZoom = 7;

  useEffect(() => {
    if (accessSession?.classroom?.address?.location) {
      setCoords({
        lat: accessSession.classroom.address.location[1],
        lng: accessSession.classroom.address.location[0],
      });
      setZoom(18);
    }
  }, []);

  const handleTypeChange = event => {
    if (!isFinished) {
      const type = event.target.value;
      setRadio(() => {
        handleChange('type')(type);
        return type;
      });
    }
  };

  const handleClassroom = (field, address = false) => event => {
    let value = event;
    if (typeof event === 'object') {
      value = event.target.value;
    }
    let updateField = field;
    if (address) {
      updateField = 'address';
      value = {
        ...typeof accessSession.classroom?.address === 'object' ? accessSession.classroom?.address : {},
        [field]: value,
      };
    }
    handleChange('classroom')({
      ...accessSession.classroom,
      [updateField]: value,
    });
  };
  const AddAddress = () => setShowAddAddress({ show: true });
  const handleCoordinateChange = (lat, lng) => {
    new Request(_csrf)
      .get('/api/address/reversegeocoding', { lat, lng }, false, false)
      .done(result => {
        if (result.data) {
          const address = result.data;
          handleChange('classroom')({
            ...accessSession.classroom,
            address: {
              ...{ ...accessSession.classroom?.address || {} },
              ...address,
              location: [lng, lat],
            },
          });
        }
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_inboxMessageCreate');
      });
  };

  const updateCoordinatesFromAddress = address => new Promise((resolve, reject) => {
    const street = address.address_2 ? `${address.address_1}, ${address.address_2}` : address.address_1;
    new Request(_csrf)
      .get('/api/address/geocoding', {
        street,
        country: address.country,
        city: address.city,
      }, false, false)
      .done(result => {
        if (result.data) {
          resolve(result.data);
        } else {
          resolve(null);
        }
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_inboxMessageCreate');
        reject(null);
      });
  });

  useEffect(() => {
    if (accessSession.classroom?.address?.location) {
      const latLng = {
        lat: accessSession.classroom.address.location[1],
        lng: accessSession.classroom.address.location[0],
      };
      if (mapMarker) {
        mapMarker.setPosition(latLng);
      }
      if (mapObj && !mapObj.getBounds().contains(latLng)) {
        mapObj.setCenter(latLng);
        setZoom(18);
      }
    }
  }, [accessSession.classroom?.address?.location, zoom]);

  const handlePlaceLocationChange = type => value => {
    onClassroomUpdate(type, value);
  };

  useEffect(() => {
    setUpdatedAddress(accessSession.classroom?.address?.address);
  }, [accessSession.classroom?.address?.address]);

  return (
    <>
      <div className="tab-session_details">
        <div className="form-group m-form__group row filters-sessions">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
          <label
            className="col-form-label col-lg-3 col-md-1 col-sm-12 text-right typeSession-label"
          >
            {t('access_session.detail.typeSession')}
          </label>
          <label
            htmlFor="webinar"
            className="col col-lg-3 radio radial-sessions"
          >
            <span className="radio__input">
              <input
                id="webinar"
                type="radio"
                name="typeSession"
                value="webinar"
                checked={accessSession.type === 'webinar'}
                onChange={handleTypeChange}
              />
              <span className="btn radio__control">
                <span className="radio__label">{t('access_session.detail.webinar')}</span>
                <i style={{ display: 'none' }} className="fas fa-check" />
              </span>
            </span>
          </label>
          <label
            htmlFor="classroom"
            className="col-md-auto col-lg-3 radio radial-sessions"
          >
            <span className="radio__input">
              <input
                id="classroom"
                type="radio"
                name="typeSession"
                value="classroom"
                checked={accessSession.type === 'classroom'}
                onChange={handleTypeChange}
              />
              <span className="btn radio__control">
                <span className="radio__label">{t('access_session.detail.classroom')}</span>
                <i style={{ display: 'none' }} className="fas fa-check" />
              </span>
            </span>
          </label>
        </div>
      </div>
      {radio === 'webinar' && (
        <TabSessionDetailsWebinar
          accessSession={accessSession}
          createUser={createUser}
          handleChange={handleChange}
          isFinished={isFinished}
          createTrainer={createTrainer}
          isWebexActive={isWebexActive}
          isDuplicate={isDuplicate}
        />
      )}
      {(radio === 'classroom')
        ? (<div className="tab2-classroom row">
          <div className="col-lg-6 block-classroom">
            {createUser('host', 'col-2 text-right', 'col-9 row no-gutters')}
            <div className="row">
              <div className="col-lg-12 form-group m-form__group row input-classroom">
                <label
                  htmlFor="linkClassroom"
                  className="col-form-label col-2 text-right"
                >
                  {t('access_session.detail.link')}
                </label>
                <div className="col-10 col-lg-10">
                  <input
                    type="text"
                    id="linkClassroom"
                    name="linkClassroom"
                    className="form-control m-input"
                    value={accessSession.classroom?.link || ''}
                    onChange={handleClassroom('link')}
                    placeholder={t('access_session.detail.zoomLink.placeholder')}
                    disabled={isFinished}
                  />
                </div>
              </div>
            </div>
            <PlaceLocation
              accessSession={accessSession}
              isFinished={isFinished}
              handleChange={handlePlaceLocationChange}
              updatedAddress={accessSession.classroom?.placeLocation?.address || ''}
            />
            <div className="row">
              <div className="col-lg-12 form-group m-form__group input-classroom row">
                <label
                  htmlFor="address"
                  className="col-form-label col-2 col-lg-2 text-right"
                >
                  {t('access_session.detail.address')}
                </label>
                <div className="col-8 col-lg-8">
                  <GoogleInput
                    placeholder={t('access_session.detail.address.placeholder')}
                    updateValue={updatedAddress}
                    id="addressInput"
                    name="address"
                    defaultValue={accessSession.classroom?.address?.address || ''}
                    onSetValue={handleClassroom('address', true)}
                    onChange={address => {
                      handleChange('classroom')({
                        ...accessSession.classroom,
                        address,
                      });
                    }}
                    disabled={isFinished}
                  />
                </div>
                <button
                  type="button"
                  onClick={AddAddress}
                  className="btn btn-brand btn-sm col-2 google-margin"
                  disabled={isFinished}
                >
                  {t('access_session.detail.edit')}
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 input-classroom form-group m-form__group row">
                <label
                  htmlFor="notes"
                  className="col-form-label col-2 text-right"
                >
                  {t('access_session.detail.notes')}
                </label>
                <div className="col-10">
                  <textarea
                    id="notes"
                    name="notes"
                    className="form-control m-input col-12"
                    value={accessSession.classroom?.notes || ''}
                    onChange={handleClassroom('notes')}
                    placeholder={t('access_session.detail.notes.placeholder')}
                    disabled={isFinished}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="google-maps_block">
                <GoogleMapReact
                  bootstrapURLKeys={{ key: mapsKey }}
                  defaultCenter={coords}
                  defaultZoom={defaultZoom}
                  onClick={position => {
                    if (!isFinished) {
                      // Distinguish between a dragend and map click outside marker
                      if (position.event.target.tagName !== 'AREA') {
                        handleCoordinateChange(position.lat, position.lng);
                      } else {
                        const latLng = mapMarker.getPosition();
                        handleCoordinateChange(latLng.lat(), latLng.lng());
                      }
                    }
                  }}
                  yesIWantToUseGoogleMapApiInternals
                  onGoogleApiLoaded={({ map, maps }) => {
                    const myLatLng = coords;
                    const marker = new maps.Marker({
                      position: myLatLng,
                      map,
                      draggable: !isFinished,
                    });
                    setMap(() => {
                      setMapMarker(marker);
                      return map;
                    });
                  }}
                  zoom={zoom}
                  options={isFinished ? { gestureHandling: 'none' } : {}}
                />
              </div>
            </div>
            {/* TODO: attendance link
            <div className="row">
              <div className="col-lg-12 input-classroom">
                <label
                  htmlFor="attendanceLink"
                  className="col-form-label col-2 text-right"
                >
                  {t('access_session.detail.attendanceLink')}
                </label>
                <input
                  type="text"
                  id="addressInput"
                  name="attendanceLink"
                  className="form-control m-input col-5"
                  onChange={handleClassroom('address')}
                />
                <button
                  type="button"
                  className="btn btn-metal btn-sm disabled generate-link col-lg-2"
                >
                  {t('access_session.detail.qr')}
                </button>
              </div>
            </div>
            <div className="row">
              <label
                htmlFor="qr-code"
                className="col-form-label col-5 text-right"
              >
                {t('access_session.detail.generatedQR')}
              </label>
              <span className="qr-code" />
            </div> */}
          </div>
          <div className="col-lg-6 mobile-session-details">
            <div className="col-lg-12 block-classroom">
              {createTrainer('trainer', 'col-2 text-right', 'col-9 row no-gutters')}
            </div>
            <div className="col-lg-12 block-classroom">
              {selectMultiple(
                'courses',
                courses.map(c => ({ id: c._id, text: c.name })),
                'col-2 text-right',
                'col-9',
              )}
            </div>
          </div>
           </div>)
        : null
      }
      {showAddAddress.show &&
      <AddAddressModal
        address={accessSession.classroom?.address}
        onClose={async updateState => {
          if (updateState) {
            let saveState = updateState;
            let location = null;
            try {
              location = await updateCoordinatesFromAddress(updateState);
            } catch (err) {
              location = null;
            }
            if (location) {
              saveState = {
                ...saveState,
                address: location.address,
                location: location.location,
                country: location.country,
              };
            }
            setShowAddAddress(() => {
              handleChange('classroom')({
                ...accessSession.classroom,
                address: {
                  ...{ ...accessSession.classroom?.address || {} },
                  ...saveState,
                },
              });
              return { show: false };
            });
          } else {
            setShowAddAddress(() => ({ show: false }));
          }
        }}
        countries={countries}
      />
      }
    </>
  );
};

TabSessionDetails.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  accessSession: PropTypes.shape(accessSessionProp.propType).isRequired,
  createUser: PropTypes.func.isRequired,
  createTrainer: PropTypes.func.isRequired,
  selectMultiple: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape(courseProp.propType)).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  mapsKey: PropTypes.string,
  isFinished: PropTypes.bool,
  onClassroomUpdate: PropTypes.func.isRequired,
  isWebexActive: PropTypes.bool,
  isDuplicate: PropTypes.bool,
};
TabSessionDetails.defaultProps = {
  mapsKey: '',
  isFinished: false,
  isWebexActive: false,
  isDuplicate: false,
};

export default translate(TabSessionDetails);
